import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getFeatureFlags } from './getFeatureFlags.helper';

type FeatureFlagConfig = {
  [key: string]: { isEnabled: boolean; data?: unknown[] };
};

interface FeatureFlagsState {
  flags: FeatureFlagConfig;
}

const initialState: FeatureFlagsState = {
  flags: getFeatureFlags()
};

export const featureFlagsSlice = createSlice({
  name: 'featureFlags',
  initialState,
  reducers: {
    updateFeatureFlag: (state, action: PayloadAction<{ key: string; isEnabled: boolean }>) => {
      const { key, isEnabled } = action.payload;
      if (state.flags[key]) state.flags[key].isEnabled = isEnabled;
    }
  }
});

export const FeatureFlagActions = featureFlagsSlice.actions;
export const FeatureFlagsReducer = featureFlagsSlice.reducer;
